import React from "react";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Input,
  Label,
  CardFooter,
  FormGroup,
  Form,
} from "reactstrap";
import * as Server from "../Server";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

class SubCategoryEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      category: props.category || {},
      Categories: props.Categories || {},
      subCategory: props.subCategory || {},
    };
    this.updateSubCategory = this.updateSubCategory.bind(this);
    this.createSubCategory = this.createSubCategory.bind(this);
  }

  componentDidMount() {}

  getSubCategories = async (event) => {
    this.setState({
      category: this.state.Categories.find(
        (category) => category._id === event.target.value
      ),
    });
  };

  createSubCategory = async (event) => {
    try {
      event.preventDefault();
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "/category/web/createSubCategory",
        method: "POST",
        data: {
          name: this.state.subCategory.name,
          categoryId: this.state.category._id,
          categoryName: this.state.category.name,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.closeEditPage(true);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateSubCategory = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "/category/web/updateSubCategory",
        method: "POST",
        data: {
          subCategoryId: this.state.subCategory._id,
          name: this.state.subCategory.name,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.closeEditPage(true);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    this.setState({
      file: fileUploaded,
      fileName: fileUploaded.name,
    });
  };

  closeEditPage = (value) => {
    this.props.closeSubCategoryEditPage({ refreshList: value });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title={
            this.props.editSubCategoryKey
              ? "Edit SubCategory"
              : "Add SubCategory"
          }
          breadcrumbs={[
            {
              name: this.props.editSubCategoryKey
                ? "Edit SubCategory"
                : "Add SubCategory",
              active: true,
            },
          ]}
        >
          <Row>
            <Col>
              <Card className="mb-3">
                <CardBody>
                  <Form
                    onSubmit={
                      this.props.editSubCategoryKey
                        ? this.updateSubCategory
                        : this.createSubCategory
                    }
                  >
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="name">Name</Label>
                          <Input
                            type="text"
                            name="name"
                            required
                            value={this.state.subCategory.name || ""}
                            placeholder="Name"
                            autoComplete="off"
                            onChange={(event) =>
                              this.setState({
                                subCategory: {
                                  ...this.state.subCategory,
                                  name: event.target.value,
                                },
                              })
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        {this.props.editSubCategoryKey ? (
                          <FormGroup>
                            <Label for="categoryName">Category Name</Label>
                            <Input
                              type="text"
                              name="categoryName"
                              disabled
                              value={this.state.category.name || ""}
                            />
                          </FormGroup>
                        ) : (
                          <FormGroup>
                            <Label>Category Name</Label>
                            <br />
                            <select
                              style={{ width: "100%" }}
                              className="btn selectCss"
                              onChange={(event) => {
                                this.getSubCategories(event);
                              }}
                            >
                              {this.state.Categories.map((category, index) => (
                                <option value={category._id} key={index}>
                                  {category.name}
                                </option>
                              ))}
                            </select>
                          </FormGroup>
                        )}
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col>
                        {this.props.editSubCategoryKey ? (
                          <Button color="primary" type="submit">
                            Update
                          </Button>
                        ) : (
                          <Button color="primary" type="submit">
                            Create
                          </Button>
                        )}
                      </Col>
                      <Col>
                        <Button
                          color="secondary"
                          onClick={(event) => {
                            this.closeEditPage(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
                <CardFooter></CardFooter>
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default SubCategoryEdit;
